(function (app, ng) {

    addHouseholdRelationshipController.$inject = [
        "$mdDialog", "clientApi", "householdRelationshipApi", "$q", "_householdRelationshipTypes", "_", "personApi",
        "genders", "_states", "client", "clientTypes", "_formPattern"
    ];
    app.controller("addHouseholdRelationshipController", addHouseholdRelationshipController);

    function addHouseholdRelationshipController($mdDialog, clientApi, householdRelationshipApi, $q, householdRelationshipTypes, _, personApi, genders, states, client, clientTypes, formPattern) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                close: close,
                searchClients: searchClients,
                addClientRelationship: addClientRelationship,
                // TODO: add trusts back in
                //addTrustRelationship: addTrustRelationship,
                householdRelationshipTypes: householdRelationshipTypes,
                type: "Other",
                genders: genders,
                states: states,
                client: client,
                selectedItemChange: selectedItemChange,
                resetPerson: resetPerson,
                ssnUpdated: ssnUpdated,
                ui: {},
                formPattern: formPattern,
                clientTypes: clientTypes,
                person: {}
            });
        function close() { return $mdDialog.cancel(); }

        function searchClients(term) {
            return clientApi.searchClients(term).then(function (result) {
                result = _.filter(result, function (row) { return row.Id !== $ctrl.client.Id; });

                ng.forEach($ctrl.household,
                    function (household) {
                        _.remove(result,
                            function (row) {
                                return row.Id === household.TargetClient.Id;
                            });
                    });

                ng.forEach(result,
                    function (row) {
                        row.Term = row.Person.FirstName + " " + row.Person.LastName;
                        if (row.Person.NickName) row.Term += ` (${row.Person.NickName})`;
                    });
                return result;
            });
        }

        function ssnUpdated(clientRelationship) {
            if ($ctrl.person.Person.Ssn && $ctrl.person.Person.Ssn.length === 9 && /^\d+$/.test($ctrl.person.Person.Ssn)) {
                $ctrl.focusInput = false;
                $ctrl.person.LastFourSsn = $ctrl.person.Person.Ssn.substring($ctrl.person.Person.Ssn.length - 4);
                clientRelationship.SsN.$error.ssnInvalid = false;
                $ctrl.ui.showFullSsn = false;
            } else {
                if (!$ctrl.person.Person.Ssn || $ctrl.person.Person.Ssn.length === 0) {
                    clientRelationship.SsN.$error.ssnInvalid = false;
                    $ctrl.person.LastFourSsn = null;
                } else
                    clientRelationship.SsN.$error.ssnInvalid = true;

                $ctrl.ui.showFullSsn = true;
            }
        }

        function selectedItemChange(item) {
            if (!item)
                return $ctrl.resetPerson();
            else
                return personApi.get(item.Id).then(function (person) {
                    $ctrl.person.Id = item.Id;
                    $ctrl.person.Person = person;
                    $ctrl.person.Ssn = person.LastFourSsn;
                    $ctrl.person.TypeId = null;
                    var promises = [];
                    if (person.PrimaryPhoneNumberId)
                        promises.push(personApi.getPrimaryPhoneNumber(item.Id).then(function (phone) {
                            $ctrl.person.PhoneNumber = phone;
                        }));
                    if (person.PrimaryEmailAddressId)
                        promises.push(personApi.getPrimaryEmailAddress(item.Id).then(function (email) {
                            $ctrl.person.EmailAddress = email;
                        }));
                    if (person.PrimaryPhysicalAddressId)
                        promises.push(personApi.getPrimaryPhysicalAddress(item.Id).then(function (address) {
                            $ctrl.person.PhysicalAddress = address;
                        }));

                    return $q.all(promises);
                });
        }

        function resetPerson() {
            return $ctrl.person = {
                PhoneNumber: { Type: "Other" },
                EmailAddress: { Type: "Other" },
                PhysicalAddress: { Type: "Other" },
                Person: {
                    TypeId: (_.find(clientTypes, function (row) { return row.Name === "Household"; }) ||
                        clientTypes[0]).Id
                },
                LastFourSsn: null
            };
        }

        var missingRelationshipAlert = $mdDialog.alert({
            focusOnOpen: false,
            title: "Please select a relationship type",
            ariaLabel: "Missing relationship type alert",
            ok: "Close",
            skipHide: true,
            multiple: true
        });

        var errorAlert = $mdDialog.alert({
            focusOnOpen: false,
            title: "An error has occured.",
            ariaLabel: "Error alert",
            ok: "Close",
            skipHide: true,
            multiple: true
        });

        function addClientRelationship(form, $event) {
            if (!$ctrl.householdRelationshipType) {
                return $mdDialog.show(missingRelationshipAlert.targetEvent($event.currentTarget.parentElement));
            } else if (form.$valid) {
                $ctrl.ui.saving = true;
                if ($ctrl.person.Id) {
                    var obj = {
                        SourceClient: { Id: $ctrl.client.Id },
                        TargetClient: {
                            Id: $ctrl.person.Id,
                            Person: $ctrl.person.Person
                        },
                        Type: $ctrl.householdRelationshipType
                    };
                    var promises = [];
                    promises.push(householdRelationshipApi.addHouseholdRelationship($ctrl.person.Id,
                        {
                            SourceClient: { Id: $ctrl.person.Id, Person: $ctrl.person.Person },
                            TargetClient: { Id: $ctrl.client.Id },
                            Type: _.find($ctrl.householdRelationshipTypes,
                                function (row) {
                                    return row.ShortName === $ctrl.householdRelationshipType;
                                }).Opposite
                        }));
                    promises.push(householdRelationshipApi.addHouseholdRelationship($ctrl.client.Id, obj).then(function (rel) {
                        obj.TargetClient.Type = { Name: $ctrl.person.Person.UserType }; //add client status to return obj
                        return obj.Id = rel.Id;
                    }));
                    return $q.all(promises).then(function () {
                        return $mdDialog.hide(obj);
                    }, function () {
                        $ctrl.ui.saving = false;
                        return $mdDialog.show(errorAlert.targetEvent($event.currentTarget.parentElement));
                    });
                } else {
                    $ctrl.person.PrimaryAdvisorId = $ctrl.client.PrimaryAdvisorId;
                    if ($ctrl.ui.Dob)
                        $ctrl.person.Person.Dob = new Date($ctrl.ui.Dob);
                    return clientApi.add($ctrl.person).then(function (client) {
                        $ctrl.person.Id = client.Id;
                        $ctrl.person.Person.Id = client.Id;
                        var obj = {
                            SourceClient: { Id: $ctrl.client.Id },
                            TargetClient: $ctrl.person,
                            Type: $ctrl.householdRelationshipType
                        };

                        var contactInfo = {
                            PhoneNumber: $ctrl.person.PhoneNumber,
                            EmailAddress: $ctrl.person.EmailAddress, 
                            PhysicalAddress: ($ctrl.person.PhysicalAddress && $ctrl.person.PhysicalAddress.Line1 && $ctrl.person.PhysicalAddress.City && $ctrl.person.PhysicalAddress.State && $ctrl.person.PhysicalAddress.PostalCode) ? $ctrl.person.PhysicalAddress : null
                        }                        
                        var promises = [];
                        promises.push(personApi.update($ctrl.person.Person));
                        if ($ctrl.person.PhoneNumber || $ctrl.person.EmailAddress || $ctrl.person.PhysicalAddress)
                            promises.push(personApi.AddAllContactInfo($ctrl.person.Id, contactInfo));
                        if ($ctrl.person.Person.Ssn)
                            promises.push(personApi.updateSsn($ctrl.person.Id, { Ssn: $ctrl.person.Person.Ssn }));
                        return $q.all(promises).then(function () {
                            promises = [];
                            promises.push(householdRelationshipApi.addHouseholdRelationship($ctrl.client.Id, obj)
                                .then(function (rel) {
                                    obj.TargetClient.Type = { Name: _.find(clientTypes, function (row) { return row.Id === $ctrl.person.TypeId; }).Name }; //add client status to return obj
                                    obj.Id = rel.Id;
                                }));
                            promises.push(householdRelationshipApi.addHouseholdRelationship($ctrl.person.Id,
                                {
                                    SourceClient: $ctrl.person,
                                    TargetClient: { Id: $ctrl.client.Id },
                                    Type: _.find($ctrl.householdRelationshipTypes,
                                        function (row) {
                                            return row.ShortName === $ctrl.householdRelationshipType;
                                        }).Opposite
                                }));
                            $q.all(promises).then(function () {
                                return $mdDialog.hide(obj);
                            });
                        });
                    }, function () {
                        $ctrl.ui.saving = false;
                    });
                }
            }
        }

        $ctrl.$onInit = () => {
            $ctrl.person.TypeId = (_.find(clientTypes, function (row) { return row.Name === "Household"; }) ||
                clientTypes[0]).Id;
            $ctrl.householdRelationshipType = "Spouse";
        };
    }
})(window.app, window.angular); //jshint ignore:line